import { PodMgmt } from "Main/PodMgmt/PodMgmt"

export const AdminPods = () => {
    return <PodMgmt />
}